import { render, staticRenderFns } from "./ExpensesOtherOverheads.vue?vue&type=template&id=7488b010"
import script from "./ExpensesOtherOverheads.vue?vue&type=script&lang=js"
export * from "./ExpensesOtherOverheads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports